// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'botiga-30d3f',
    appId: '1:137295652062:web:8048222718c6589f99ce4f',
    databaseURL: 'https://botiga-30d3f.firebaseio.com',
    storageBucket: 'botiga-30d3f.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyAksNh7-n5ki938dy4T6NtloYj7VHF-vyQ',
    authDomain: 'botiga-30d3f.firebaseapp.com',
    messagingSenderId: '137295652062',
    measurementId: 'G-13CYWTGFS1',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
